<template>
  <div>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
            v-model="brandSelected"
            @setBrand="setBrand"
        ></BrandDropdown>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
              class="form-control w-auto"
              v-model="perPage"
              :options="pageOptions"
              @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
              id="searchText"
              type="text"
              v-model="searchText"
              class="form-control w-50"
              @change="getJobList"
          />
        </div>
      </div>

      <b-table
          class="table table-bordered w-100 crm-job-table"
          hover
          responsive
          :items="listJobData"
          :fields="fieldsReportJob"
          @sort-changed="sortCompare"
      >
        <template #thead-top>
          <b-tr>
            <b-th colspan="6">
              <span class="d-flex justify-content-start gap-2">
                <button @click="getJobList">
                  <font-awesome-icon :icon="['fas', 'sync']" />
                </button>
                <small class="font-weight-regular">
                  Please refresh to see the latest results.</small
                >
              </span>
            </b-th>
          </b-tr>
        </template>
        <template #cell(request)="data">
          <span style="white-space: pre-wrap">{{ data.item.request }}</span>
        </template>
        <template #cell(status)="data">
          <v-chip
              v-if="data.item.status === 'COMPLETED'"
              color="#C8E6C9"
              text-color="#1B5E20"
              variant="flat"
          >
            {{ data.item.status }}
          </v-chip>

          <v-chip
              v-else
              color="#CFE8FC"
              text-color="#0D47A1"
              variant="flat"
          >
            {{ data.item.status }}
          </v-chip>
        </template>
        <template #cell(action)="data">
          <div
              class="d-flex justify-content-evenly"
              v-if="data.item.status === 'COMPLETED'"
          >
            <router-link
                :to="{
                name: 'DetailAgeGroupReport',
                query: {
                  id: data.item.id,
                  processId: data.item.processId,
                },
              }"
                class="btn btn-outline-primary"
            >Detail</router-link
            >
          </div>
          <div
              class="d-flex justify-content-evenly"
              v-else
          >
            <span class="grey--text">Waiting...</span>
          </div>
        </template>
        <template #table-caption v-if="listJobData.length === 0">
          <h5 class="text-center pt-10">
            There is no history of filtering Customer Age Group
          </h5>
        </template>
      </b-table>
      <b-pagination
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
          class="my-0"
          aria-controls="my-table"
          @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import DefaultListViewData from "@/views/defaultListViewData";

export default {
  name: "MetricTable",
  components: { BrandDropdown },
  props: {
    isDataLoading: {
      type: Boolean,
      default: () => false,
    },
    listJobData: {
      type: Array,
      default: () => [],
    },
    totalRows: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      brandSelected: null,
      fieldsReportJob: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "createdBy",
          label: "Created by",
          sortable: true,
        },
        {
          key: "request",
          label: "Filters",
          class: "filter-class",
          sortable: true,
        },
        {
          key: "dateCreated",
          label: "Created at",
          class: "created-at-class",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      ...DefaultListViewData,
    };
  },
  computed: {
    isJobDataLoading: {
      get: function () {
        return this.isDataLoading;
      },
      set: function (newValue) {
        this.$emit("update:isDataLoading", newValue);
      },
    },
  },
  mounted() {
    this.getJobList();
  },
  methods: {
    getJobList() {
      const params = {
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "",
        sortType: this.sort.type || "",
        key: this.searchText,
        brandCode: this.brandSelected?.id || "",
        type: 'AGE_GROUP',
      };

      this.$emit("getRequestParams", params);
    },
    onChangeEntries() {
      this.getJobList();
    },
    changePage() {
      this.getJobList();
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getJobList();
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.getJobList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .filter-class {
  max-width: 300px !important;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
}

::v-deep .created-at-class {
  max-width: 100px !important;
}

::v-deep .request-cell {
  display: block;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
}

</style>
